export const messages = {
  admin: {
    agency: {
      select: 'Sélectionner une agence',
      display: 'Agence',
    },
  },
  home: {
    title: `
      Vous êtes un professionnel de la plomberie, de l’électricité ou du gaz ?<br><br>
      Inscrivez-vous pour rejoindre notre réseau de pro, et recevez des demandes de dépannage de nos clients dans votre secteur.<br><br>
    `,
    subTitle: '<strong>Nous avons des clients vous avez les compétences !</strong>',
    continueSignUp: 'Continuer mon inscription',
    goToSelfCare: 'Aller sur mon espace personnel',
    informations: {
      strenghts: {
        title: 'Les forces du réseau HomeServe Dépannage :',
        arguments: [
          `Vous recevez en temps réel les demandes qualifiées de nos clients : c’est gratuit, sans abonnement ni commission.`,
          `Vous avez la liberté d’accepter les demandes de dépannage qui vous intéressent, et de gérer votre planning comme vous le souhaitez.`,
          `Nous proposons des tarifs justes, en adéquation avec les standards du marché.`,
          `Nous mettons à votre disposition des outils simples pour vous faciliter la vie : une application mobile pour gérer vos interventions HomeServe Dépannage, et nous générons automatiquement vos factures.`,
          `Vous recevez votre règlement par HomeServe directement sur votre compte bancaire.`,
        ],
      },
      joinNetwork: {
        title: 'Rejoignez notre réseau',
        step1: {
          title: 'Remplissez notre formulaire d’inscription',
          description:
            'C’est simple, en quelques étapes, avec vos documents à fournir (Kbis de moins de 3 mois, assurance pro et RIB)',
        },
        step2: {
          title: `Rejoignez le réseau HomeServe`,
          description: `Notre responsable régional étudiera votre dossier, et prendra contact avec vous.`,
        },
        step3: {
          title: `Téléchargez l'application Homeserve Dépannage Pro et recevez les demandes de nos clients`,
          description: `Vous recevrez gratuitement des notifications pour des demandes de dépannages dans votre secteur.`,
        },
        step4: {
          title: `Recevez votre facture et votre paiement`,
          description: `Nous générons automatiquement votre facture, et vous recevez votre paiement sur votre compte bancaire.`,
        },
      },
      traderRequirements: {
        title: `Pour intégrer notre réseau vous devez vous engager à&nbsp;:`,
        requirements: [
          `<strong>Fixer le rendez-vous</strong> avec le client <strong>dès la réception de la demande</strong>`,
          `Disposer d'un <strong>personnel qualifié</strong> et d'<strong>équipements performants</strong>`,
          `Réaliser les travaux avec un <strong>haut niveau de qualité</strong>`,
          `<strong>Nettoyer</strong> à la fin du chantier`,
        ],
      },
    },
  },
  auth0: {
    access_denied: 'Mauvais email ou mot de passe.',
    too_many_attempts:
      'Votre compte a été bloqué après plusieurs tentatives de connexion consécutives. Nous vous avons envoyé un email avec les instructions pour le débloquer.',
  },
  common: {
    address: 'Adresse',
    joinOurNetwork: 'Rejoignez notre réseau',
    cancel: 'Annuler',
    checkAll: 'Tout cocher',
    connection: 'connexion',
    email: 'Adresse e-mail',
    emptyList: 'Cette liste est vide',
    none: 'aucun',
    false: 'Non',
    firstName: 'Prénom',
    lastName: 'Nom',
    formErrors: 'Veuillez corriger les erreurs ci-dessus',
    help: 'aide',
    isVatApplicable: 'Assujetti à la TVA',
    logout: 'déconnexion',
    notAvailable: 'n/a',
    password: 'Mot de passe',
    phone: 'Téléphone',
    pleaseWait: 'Veuillez patientez...',
    save: 'Sauvegarder',
    status: 'Status',
    true: 'Oui',
    uncheckAll: 'Tout décocher',
    update: 'Mettre à jour',
    upload: 'Ajouter un fichier',
    validate: 'Valider',
    vatNumber: 'N° TVA',
    code: 'code',
  },
  components: {
    createTraderDialog: {
      title: 'Ajouter un nouvel artisan'
    },
    fileField: {
      previewFile: 'Voir le fichier',
      selectFile: 'Sélectionner un fichier',
    },
  },
  dashboard: {
    accountPending: `Nous avons le plaisir de vous confirmer votre demande d'inscription au réseau Homeserve Dépannage. Félicitations ! Un responsable régional vous contactera dans les plus brefs délais pour finaliser cette inscription.`,
  },
  errors: {
    unexpected: 'Une erreur inattendue s’est produite.',
  },
  headings: {
    404: 'Page non trouvée',
    administrative: 'Informations administratives',
    documents: 'Documents',
    dashboard: `Dashboard`,
    home: `Accueil`,
    login: `S'authentifier`,
    tradersList: `Liste des artisans`,
    onboarding: {
      user: 'Rejoindre notre réseau',
      skills: 'Votre expertise',
      catchmentArea: `Votre zone d'intervention`,
      equipment: 'Vos équipements',
      summary: 'Récapitulatif',
    },
    selfcare: {
      administration: 'Administration',
      company: 'Entreprise',
      agencies: 'Agences',
      profile: 'profil',
    },
  },
  forgotPassword: {
    resetPassword: 'Réinitialisation de mot de passe',
    sendMeAnEmail: 'Envoyez moi un email',
    emailSent: 'Vous allez recevoir un mail pour réinitialiser votre mot de passe.',
    error: `Une erreur s'est produite, veuillez réessayer plus tard`,
    changePassword: 'Changer de mot de passe',
  },
  login: {
    signIn: 'Se connecter',
  },
  onboarding: {
    catchmentAreaForm: {
      region: `Région d'intervention`,
      catchmentArea: `Zone d'intervention`,
      hints: {
        catchmentArea: `La distance maximale d'intervention à partir de votre agence, en kilomètres`,
      },
      departments: `Sélectionnez les départements sur lesquels vous intervenez :`,
    },
    companyForm: {
      address: 'Adresse',
      birthCity: 'Lieu de naissance',
      birthDate: 'Date de naissance',
      birthCountry: 'Pays de naissance',
      differentPersonalAddress: 'Cochez la case si votre adresse personnelle est différente de celle de votre société',
      companyName: 'Raison sociale',
      companyInfos: `Informations de l'entreprise`,
      personalInfos: 'Vos informations personnelles',
      creationDate: 'Date de création',
      holderName: 'Nom du titulaire du compte',
      iban: 'IBAN',
      isVatApplicable: `Décochez cette case si vous n'êtes pas assujettis à la TVA`,
      legalForm: 'Forme légale',
      personalAddress: 'Adresse personnelle',
      rcsCity: 'Ville RCS',
      registrationNumber: 'Numéro SIREN',
      hints: {
        iban: `Par exemple FR7610107001011234567890129`,
      },
    },
    documentsForm: {
      status_validated: 'Validé',
      status_created: 'En attente de validation',
      status_rejected: 'Rejeté',
      file: 'Fichier {type}',
      validityEndDate: {
        rcp: `Date de fin de validité de la RCP`,
      },
      validityStartDate: {
        kbis: `Date d'émission du KBIS`,
        rcp: `Date de début de validité de la RCP`,
      },
      rcpNum: 'Numéro assurance pro',
    },
    errors: {
      contactAdmin: `Veuillez contactez l'administrateur du site.`,
      emailAlreadyTaken: 'Cette adresse e-mail déjà utilisée.',
      fetchAddressDetails: `Impossible de récupérer le détail de l'adresse`,
    },
    skillsForm: {
      selectedCategory: 'une catégorie sélectionnée | {count} catégories sélectionnées',
      selectedProduct: 'un produit sélectionné | {count} produits sélectionnés',
      domainDialog: {
        title: 'Sélectionner vos domaines de compétences',
      },
    },
    summary: {
      catchmentArea: `Zone d'intervention en km`,
      departments: `Départements d'intervention`,
      domains: 'Domaines de compétences',
      equipment: 'Vos équipements',
      issueDate: `Date d'émission`,
      validityEndDate: 'Date de fin de validité',
      validityStartDate: 'Date de début de validité',
    },
    userForm: {
      postCode: 'Code postal de votre entreprise',
      hints: {
        postCode: `Veuillez taper au moins trois caractères`,
      },
      tooltips: {
        hidePassword: 'Masquer le mot de passe',
        showPassword: 'Voir le mot de passe',
      },
    },
  },
  selfcare: {
    agency: {
      regionsList: 'Liste des régions ou vous intervenez',
    },
  },
  status: {
    active: 'Active',
    inactive: 'Désactivée',
    pending: 'En attente de validation',
  },
  traderStatus: {
    active: 'Actif',
    inactive: 'Désactivé',
    pending: 'En attente de validation',
  },
  stepper: {
    next: 'Suivant',
    previous: 'Précédent',
  },
  validation: {
    custom: {
      ibanFile: {
        required: 'Merci de choisir un fichier IBAN.',
      },
      kbisFile: {
        required: 'Merci de choisir un fichier KBIS.',
      },
      kbisValidityStartDate: {
        required: `Merci de renseigner une date d'émission.`,
      },
      rcpFile: {
        required: 'Merci de choisir un fichier RCP.',
      },
      rcpValidityEndDate: {
        required: 'Merci de renseigner une date de fin de validité.',
        date_greater_than: 'Doit être supérieur à la date de début de validité.',
      },
      rcpValidityStartDate: {
        required: 'Merci de renseigner une date de début de validité.',
        date_lesser_than: 'Doit être inférieur à la date de fin de validité.',
      },
      domains: {
        required: `Merci de sélectionner au moins un domaine d'expertise.`,
      },
      products: {
        required: `Merci de sélectionner au moins une catégorie d'expertise.`,
      },
      departments: {
        required: `Merci de sélectionner au moins un départment.`,
      },
    },
    messages: {
      password: `Le champ {0} doit contenir au minimum une minuscule, une majuscule et un chiffre.`,
      siren: `Le champ {0} doit être un numéro SIREN valide.`,
    },
  },
};
